import { useState } from "react";
import PropTypes from 'prop-types';

const TextArea = (props) => {
    const [charCount, setCharCount] = useState(0);
    const showCounter = !!props.maxLength;

    const register = props.register ? {
        ...props.register,
        onChange: (e) => {
            setCharCount(e.target.value.length);
            return props.register.onChange?.(e);
        }
    } : {};

    return (
        <div className={`${props.className}`}>
            <label htmlFor={props.id} className="capitalize text-sm leading-tight tracking-normal flex mb-1 mt-2">
                {props.label}
            </label>

            <textarea
                {...props}
                id={props.id}
                {...register}
                className="text-gray-600 focus:outline-none focus:border focus:border-blue-700 font-normal w-full h-auto flex items-center text-sm border-gray-300 rounded border"
            />

            <div className="flex justify-between items-center">
                {props.error
                    ? <p className="text-red-500 text-xs mt-1">{props?.error?.message}</p>
                    : <span />
                }
                {showCounter &&
                    <div className={`text-xs mt-0.5 ${charCount > props.maxLength ? 'text-red-500' : 'text-gray-400'}`}>
                        {charCount}/{props.maxLength}
                    </div>
                }
            </div>
        </div>
    );
}

TextArea.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node,
  id: PropTypes.string,
  register: PropTypes.object,
  error: PropTypes.object,
  maxLength: PropTypes.number,
};

export default TextArea;
